/** Dispatched after wallet-affecting flows (e.g. recharge) so the header SOL balance refetches without waiting for the poll interval. */
export const HEADER_BALANCE_REFRESH_EVENT = "autobot:header-balance-refresh";

export function requestHeaderBalanceRefresh() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(HEADER_BALANCE_REFRESH_EVENT));
}
